import React from "react";
import AccordionItem, { AccordionItemProps } from "./Item";

export type AccordionColor = "primary";

export interface AccordionProps {
  items: Array<AccordionItemProps>;
  color?: AccordionColor;
  className?: string;
  id?: string;
}

const Accordion: React.FC<AccordionProps> = ({ items, color = "primary", className }) => {
  return (
    <div className={className}>
      {items.map((item) => (
        <AccordionItem key={item.label} {...item} color={color} />
      ))}
    </div>
  );
};

export default Accordion;
